import React from 'react';
import {
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Cell,
  ResponsiveContainer,
} from 'recharts';

const RADIAN = Math.PI / 180;

const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#fff"
      textAnchor="middle"
      dominantBaseline="central"
      fontSize={12}
      fontWeight="bold"
    >
      {value}
    </text>
  );
};

const renderLegend = (props) => {
  const { payload } = props;
  const total = payload.reduce((sum, entry) => sum + (entry.payload.count || entry.payload.value || 0), 0);

  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {payload.map((entry, index) => {
        const count = entry.payload.count || entry.payload.value || 0;
        const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : 0;
        return (
          <li key={`legend-${index}`} style={{ display: 'flex', alignItems: 'center', marginBottom: 6, fontSize: 13 }}>
            <span style={{
              display: 'inline-block',
              width: 12,
              height: 12,
              borderRadius: 2,
              backgroundColor: entry.color,
              marginRight: 8,
            }} />
            <span style={{ color: '#555' }}>
              {entry.payload.name} &nbsp; {count} ({percentage}%)
            </span>
          </li>
        );
      })}
    </ul>
  );
};

const pieChart = props => {
  const innerRadius = props.innerRadius || 50;
  const outerRadius = props.outerRadius || 90;

  return (
    <ResponsiveContainer width="100%" height={props.height || 250}>
      <PieChart>
        <Pie
          dataKey={props.dataKey}
          data={props.data}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          fill="#8884d8"
          label={renderCustomLabel}
          labelLine={false}
          paddingAngle={2}
        >
          {props.colors && props.data && props.data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={props.colors[index % props.colors.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            borderRadius: 8,
            border: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          }}
        />
        {props.showLegend && <Legend content={renderLegend} layout="vertical" align="right" verticalAlign="middle" />}
      </PieChart>
    </ResponsiveContainer>
  );
};

export default pieChart;
